// extracted by mini-css-extract-plugin
export default {"wrapper":"kca-z"};